export function energyKwh(connector, nowMs, powerWatts) {
  const tx = connector?.transaction
  if (!tx) return 0
  const startMeter = Number(tx.startMeterValue) || 0
  const currentMeter = Number(tx.currentMeter) || 0
  let energyWh = Math.max(0, currentMeter - startMeter)
  const watts = Number(powerWatts) > 0 ? Number(powerWatts) : Number(connector.maxPower) || 0

  if (tx.startTime && watts > 0) {
    const start = new Date(tx.startTime)
    if (!Number.isNaN(start.getTime())) {
      const hours = Math.max(0, nowMs - start.getTime()) / 3600000
      energyWh = Math.max(energyWh, watts * hours)
    }
  }

  return energyWh / 1000
}

export function formatEnergyReading(connector, nowMs, powerWatts) {
  const kwh = energyKwh(connector, nowMs, powerWatts)
  if (kwh >= 100) return kwh.toFixed(2)
  return kwh.toFixed(2).padStart(5, '0')
}

export function formatDurationReading(startTime, nowMs) {
  if (!startTime) return '00:00:00'
  const start = new Date(startTime)
  if (Number.isNaN(start.getTime())) return '00:00:00'
  const diffMs = Math.max(0, nowMs - start.getTime())
  const hours = Math.floor(diffMs / 3600000)
  const mins = Math.floor((diffMs % 3600000) / 60000)
  const secs = Math.floor((diffMs % 60000) / 1000)
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(hours)}:${pad(mins)}:${pad(secs)}`
}

export function isLoadBalancingEnabled(station) {
  return station?.simulation?.loadBalancing !== false
}

export function ratedPowerWatts(station, connectors = []) {
  const model = String(station?.model || '')
  const fromModel = model.match(/(\d+(?:\.\d+)?)\s*k?w/i)
  if (fromModel) {
    return Math.round(Number(fromModel[1]) * 1000)
  }

  const list = connectors.length ? connectors : (station?.connectors || [])
  return list.reduce((sum, connector) => sum + (Number(connector.maxPower) || 0), 0)
}

export function chargingConnectorCount(connectors = []) {
  return connectors.filter((connector) => connector?.state === 'Charging').length
}

export function allocatedPowerWatts(station, connectors, connector) {
  const maxPower = Number(connector?.maxPower) || 0
  if (!isLoadBalancingEnabled(station) || connector?.state !== 'Charging') {
    return maxPower
  }

  const rated = ratedPowerWatts(station, connectors)
  const charging = chargingConnectorCount(connectors)
  if (charging <= 1) {
    return rated || maxPower
  }
  return Math.floor(rated / charging)
}

export function ratedPowerLabel(station, connectors = []) {
  return formatKw(ratedPowerWatts(station, connectors) / 1000)
}

export function cabinetPowerLabel(station, connectors = []) {
  const rated = ratedPowerWatts(station, connectors)
  if (!isLoadBalancingEnabled(station)) {
    return formatKw(rated / 1000)
  }

  const charging = chargingConnectorCount(connectors)
  if (charging < 2) {
    return formatKw(rated / 1000)
  }

  const shareKw = (rated / charging) / 1000
  const parts = Array.from({ length: charging }, () => formatKwNumber(shareKw))
  return `${parts.join('+')} kW`
}

function formatKwNumber(kw) {
  if (!kw) return '0'
  return kw >= 10 ? String(Math.round(kw)) : String(Math.round(kw * 10) / 10)
}

function formatKw(kw) {
  if (!kw) return '—'
  return `${formatKwNumber(kw)} kW`
}

export function chargerImageSrc(station) {
  const key = `${station?.vendor || ''} ${station?.model || ''}`.toLowerCase()
  if (key.includes('evmaxx') || key.includes('evm')) {
    return '/images/chargers/evmaxx.png'
  }
  return '/images/chargers/evmaxx.png'
}
